/**
 * Stream dropdown helpers.
 *
 * vue-select treats a falsy model value (0) as "nothing selected", so a stream
 * option with id 0 can never render as selected. "All Streams" therefore uses
 * a non-zero sentinel in the UI and is mapped back to 0 for the API.
 */
export const ALL_STREAMS_ID = -1;
export const API_NO_STREAM_ID = 0;

export function buildStreamOptions(list, allStreamsLabel) {
  const rows = Array.isArray(list) ? list : [];
  return [
    { id: ALL_STREAMS_ID, name: allStreamsLabel },
    ...rows.filter((s) => s && Number(s.id) !== API_NO_STREAM_ID),
  ];
}

export function normalizeStreamIdForUi(raw) {
  if (
    raw === 0 ||
    raw === "0" ||
    raw === null ||
    raw === undefined ||
    raw === ""
  ) {
    return ALL_STREAMS_ID;
  }
  const sid = Number(raw);
  return Number.isFinite(sid) ? sid : ALL_STREAMS_ID;
}

export function streamIdForApi(raw) {
  const sid = Number(raw);
  if (!Number.isFinite(sid) || sid === ALL_STREAMS_ID) {
    return API_NO_STREAM_ID;
  }
  return sid;
}
